import L from 'lodash'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

const changeLanguageCallbacks = []

const vuetifyCatalogs = {
  en: require(`vuetify/lib/locale/en`).default,
  es: require(`vuetify/lib/locale/es`).default,
  it: require(`vuetify/lib/locale/it`).default
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: window.envmap.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: window.envmap.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {}
})

export function i18nLoadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    // reload and merge agilis messages and add vuetify messages
    let messages = {}

    L.merge(messages, require(`./lang/${lang}.json`)) // ricarica i default
    L.merge(messages, i18n.messages[lang]) // applica le customizzazioni ricevute dalla config
    messages['$vuetify'] = vuetifyCatalogs[lang]
    i18n.setLocaleMessage(lang, messages)
    i18n.locale = lang

    changeLanguageCallbacks.forEach((cb) => {
      if (cb && typeof cb === 'function') {
        cb(lang)
      }
    })
  }
  i18n.locale = lang
  return lang
}

export function i18nMergeLanguage (lang, messages) {
  let targetLanguage = {}
  // copy current messages
  L.merge(targetLanguage, i18n.messages[lang])
  // merge new messages
  L.merge(targetLanguage, messages)
  // save merged messages
  i18n.setLocaleMessage(lang, targetLanguage)
}

export const i18nAvailableLanguages = [
  { lang: 'it', label: 'languages.it' },
  { lang: 'en', label: 'languages.en' }
]

export function registerChangeLanguageCallback (cb) {
  if (cb && typeof cb === 'function') {
    changeLanguageCallbacks.push(cb)
    cb(i18n.locale)
  }
}

// load default en messages
const enMessages = require(`./lang/en.json`)
enMessages['$vuetify'] = vuetifyCatalogs['en']
i18n.setLocaleMessage('en', enMessages)

export default i18n
